import { useClientPortalAPI } from "@certn/api";

export function useSubsidiaryCheckEligibility(country?: string) {
  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/billing-profiles/subsidiary-check-eligibility/",
    country ? { country } : undefined
  );

  return {
    isEligibleForSubsidiaryCheck: data?.is_eligible ?? false,
    isMismatched: data?.is_mismatched ?? false,
    isLoading,
  };
}
